export const SEPARACAO_E_JUNCAO_DE_INSCRICAO = 'SeparacaoEJuncaoDeInscricao';
export const SEPARACAO_E_JUNCAO_AVANCADA_DE_PROTOCOLOS = 'SeparacaoEJuncaoAvancadaDeProtocolos'; 
export const ATUALIZACAO_DE_PROTOCOLOS_PRESELECIONADOS = 'AtualizacaoDeProtocolosPreSelecionados';
export const EDITAR_INFORMACOES_DE_CONTATO = 'EditarInformacoesDeContato';
export const INATIVACAO_DE_INSCRICAO = 'InativarInscricao';